import { PlayLink } from '@ui-components/PlayLink.styles';
import PlayText, { SIZE } from '@ui-components/typography/PlayText';
import React from 'react';
import { List, ListHeading, StyledErrorPage } from './ErrorPages.styles';

const ErrorGeneral = ({ pathname }: { pathname: string }) => (
    <StyledErrorPage>
        <PlayText size={SIZE.LARGE}>Vi ber om ursäkt, men just nu går det inte att visa innehållet.</PlayText>
        <ListHeading as="h2">Det kan bero på:</ListHeading>
        <List>
            <li>Att du har tappat din uppkoppling mot internet.</li>
            <li>Att vi har tillfälliga tekniska problem.</li>
        </List>
        <ListHeading>Vad du kan göra:</ListHeading>
        <List>
            <li>Kontrollera att du är ansluten till internet.</li>
            <li>
                Testa att <PlayLink href={pathname}>ladda om sidan.</PlayLink>
            </li>
            <li>Återkom om en stund så är problemet förhoppningsvis löst.</li>
        </List>
    </StyledErrorPage>
);

export default ErrorGeneral;
